export const navbarOpenHeight = 120;
export const navbarClosedHeight = 76;
export const mobileNavbarHeight = 64;
